import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { ROUTE_HOME } from "../../constants/routes";
import { fullPageCentered, contentMaxWidth } from "../../styles/layoutStyles";

/**
 * Welcome page at "/" – entry point with link to admin.
 */
const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        ...fullPageCentered,
        background: "linear-gradient(180deg, #f5f7fa 0%, #e8eef5 100%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          textAlign: "center",
          width: "100%",
          maxWidth: contentMaxWidth,
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          fontWeight={700}
          color="primary.main"
          gutterBottom
          sx={{
            fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
            lineHeight: 1.2,
          }}
        >
          Welcome to KivuIms dashboard
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            mt: 2,
            fontSize: "clamp(0.9375rem, 2vw, 1.125rem)",
            maxWidth: "36ch",
            mx: "auto",
          }}
        >
          Manage companies, memberships, subscriptions and more from the admin
          portal.
        </Typography>
        <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate(ROUTE_HOME)}
            sx={{
              px: { xs: 3, sm: 4 },
              py: 1.5,
              fontSize: "clamp(0.9375rem, 1.5vw, 1.125rem)",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: 2,
              boxShadow: "0 4px 14px rgba(25, 118, 210, 0.35)",
            }}
          >
            Get started
          </Button>
        </motion.div>
      </motion.div>
    </Box>
  );
};

export default WelcomePage;
